module.exports = __webpack_public_path__ + "img/packages/l1.432bcf.png";